import React from "react";

const LeftFeature = ({ title, description, features, imageSrc, imageAlt }) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-10 p-8 bg-white">
      {/* Left Section */}
      <div className="flex-1" data-aos="fade-up">
        <h1 className="text-2xl md:text-3xl font-bold mb-4">{title}</h1>
        <p className="text-gray-600 mb-6">{description}</p>
        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center">
              <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
              {feature}
            </li>
          ))}
        </ul>
        <button className="px-6 py-2 border border-black rounded-full hover:bg-black hover:text-white transition">
          Explore More →
        </button>
      </div>

      {/* Right Section */}
      <div className="flex-1" data-aos="fade-down">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="rounded-md "
        />
      </div>
    </div>
  );
};

export default LeftFeature;
